// extracted by mini-css-extract-plugin
module.exports = {"table_th":"styles_table_th__dEPE-"};